import React, { TextareaHTMLAttributes } from 'react';
import Color from 'color';
import styled from 'styled-components';

const StyledWrapper = styled.div`
  color: ${(props) => Color(props.theme.colors.primary_active).alpha(0.65).lighten(0.5).string()};
`;

const StyleTextArea = styled.textarea`
  border: 0;
  &:focus {
    outline: none;
    box-shadow: 0 0 0 1px var(color), 0 0 0 1px var(color);
  }
`;

export const StyledTextArea = (props) => {
  return (
    <StyledWrapper>
      <StyleTextArea {...props} />
    </StyledWrapper>
  );
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/FiveStarSurvey/components/TextArea.tsx